import { EvConnectorCcs2Component } from './ev-connector-ccs2.icon'
import { EvConnectorCeeBlueComponent } from './ev-connector-cee-blue.icon'
import { EvConnectorCeeRedComponent } from './ev-connector-cee-red.icon'
import { EvConnectorChaDemoIconComponent } from './ev-connector-chademo.icon'
import { EvConnectorJ1772IconComponent } from './ev-connector-j1772.icon'
import { EvConnectorJ1772ComboIconComponent } from './ev-connector-j1772Combo.icon'
import { EvConnectorNema1450IconComponent } from './ev-connector-nema1450.icon'
import { EvConnectorNema515IconComponent } from './ev-connector-nema515.icon'
import { EvConnectorTeslaComponent } from './ev-connector-tesla.icon'
import { EvConnectorType2Component } from './ev-connector-type2.icon'
import { EvConnectorUnknownComponent } from './ev-connector-unknown.icon'

export function EvConnectorsIcons() {
  return [
    EvConnectorNema1450IconComponent,
    EvConnectorNema515IconComponent,
    EvConnectorChaDemoIconComponent,
    EvConnectorJ1772ComboIconComponent,
    EvConnectorJ1772IconComponent,
    EvConnectorTeslaComponent,
    EvConnectorUnknownComponent,
    EvConnectorType2Component,
    EvConnectorCcs2Component,
    EvConnectorCeeBlueComponent,
    EvConnectorCeeRedComponent,
  ]
}

export * from './ev-connector-ccs2.icon'
export * from './ev-connector-cee-blue.icon'
export * from './ev-connector-cee-red.icon'
export * from './ev-connector-chademo.icon'
export * from './ev-connector-j1772.icon'
export * from './ev-connector-j1772Combo.icon'
export * from './ev-connector-nema1450.icon'
export * from './ev-connector-nema515.icon'
export * from './ev-connector-tesla.icon'
export * from './ev-connector-type2.icon'
export * from './ev-connector-unknown.icon'

